
<template>
    <div class="c-text-section section o-section__max-w">
        <h1>PRIVACY POLICY</h1>
        <p class="c-text-section--no-border">Any customer information that Artful Dodgers collects is simply to ensure that purchases can be processed in an effective and timely manner. All the information that we receive is kept secure and will not be disclosed to any other parties, no matter what the circumstances.</p>
        <p>If you allow us Artful Dodgers may use the information that you provide to inform you of new goods and services via email. If you’d prefer that we didn’t, please click the unsubscribe link at the bottom of any Artful Dodgers email you receive.</p>
        <h2>PAYMENT</h2>
        <p class="c-text-section--no-border">We can accept direct credit to our bank account in New Zealand only. Choose bank transfer during checkout and you will be emailed further instructions.</p>
        <p class="c-text-section--no-border">We accept all major debit and credit cards from customers in every country.</p>
        <p>Artful Dodgers respects your privacy. Buying a luxury item on the internet can feel a little intimidating. In reality it’s significantly more secure than handing over your credit card in a physical store. Our credit card payment system is handled by stripe. Stripe has been audited by a PCI-certified auditor and is certified to PCI Service Provider Level 1. This is the most stringent level of certification available in the payments industry. Our website uses the industry standard security protocol Secure Sockets Layer (SSL) to store and safely transmit your personal and credit card information through our systems.</p>

        <h1>COOKIES POLICY</h1>
        <p class="c-text-section--no-border">Last updated: 4th September 2018</p>
        <p class="c-text-section--no-border">Artful Dodgers uses cookies on ArtfulDodgers.co.nz. By using this website, you consent to the use of cookies.</p>
        <p class="c-text-section--no-border">Our Cookies Policy explains what cookies are, how we use cookies, how third-parties we may partner with may use cookies on the Service, your choices regarding cookies and further information about cookies.</p>

        <div class="c-accordion">
            <h2 class="c-accordion__header c-accordion__header--open" v-on:click="toggleAccordion($event)">WHAT ARE COOKIES?</h2>
            <div class="c-accordion__content">
                <p class="c-text-section--no-border">Cookies are small pieces of text sent by your web browser by a website you visit. A cookie file is stored in your web browser and allows the Service or a third-party to recognize you and make your next visit easier and the Service more useful to you.</p>
                <p class="c-text-section--no-border">Cookies can be "persistent" or "session" cookies.</p>
            </div>
        </div>

        <div class="c-accordion">
            <h2 class="c-accordion__header" v-on:click="toggleAccordion($event)">HOW ARTFUL DODGERS USES COOKIES</h2>
            <div class="c-accordion__content">
                <p class="c-text-section--no-border">When you use and access the Service, we may place a number of cookies files in your web browser.</p>
                <p class="c-text-section--no-border">We use cookies for the following purposes: to enable certain functions of the Service, to provide analytics, to store your preferences, to enable advertisements delivery, including behavioral advertising.</p>
                <p class="c-text-section--no-border">We use both session and persistent cookies on the Service and we use different types of cookies to run the Service:</p>
                <p class="c-text-section--no-border">Essential cookies. We may use essential cookies to authenticate users and prevent fraudulent use of user accounts.</p>
            </div>
        </div>

        <div class="c-accordion">
            <h2 class="c-accordion__header" v-on:click="toggleAccordion($event)">THIRD-PARTY COOKIES</h2>
            <div class="c-accordion__content">
                <p class="c-text-section--no-border">In addition to our own cookies, we may also use various third-parties cookies to report usage statistics of the artfuldodgers.co.nz</p>
            </div>
        </div>

        <div class="c-accordion">
            <h2 class="c-accordion__header" v-on:click="toggleAccordion($event)">WHAT ARE YOUR CHOICES REGARDING COOKIES?</h2>
            <div class="c-accordion__content">
                <p class="c-text-section--no-border">If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser.</p>
                <p class="c-text-section--no-border">Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly.</p>
            </div>
        </div>

        <a class="c-btn c-btn__link c-btn__link--back" @click="$router.go(-1)">Go back</a>
    </div>
</template>

<script>
    export default {
        metaInfo: {
            title: 'Privacy Policy',
            meta: [
                { name: 'description', content: 'The Artful Dodgers Ltd Ring. Privacy Policy'},
                { property: 'og:title', content: 'Privacy Policy | Artful Dodgers Ltd'},
                { property: 'og:site_name', content: 'Artful Dodgers'},
                { property: 'og:description', content: 'The Artful Dodgers Ltd. Treat yourself!'},
                { property: 'og:type', content: 'privacy policy'},
                { property: 'og:url', content: 'https://artfuldodgers.co.nz/privacypolicy'},
                { property: 'og:image', content: 'https://artfuldodgers.co.nz/assets/img/ad-trixy-ring.png'}
            ]
        },
        data: function() {
            return {
            }
        },
        methods: {
            toggleAccordion(event){
                $(event.target).toggleClass("c-accordion__header--open");
                $(event.target).next().slideToggle();
            }
        },
        mounted: function() {
            this.$nextTick(function () {
                $('.c-accordion__content').each(function(i, e){
                    if (i > 0){
                        $(e).slideUp();
                    }
                })
            })
        }
    }
</script>




// WEBPACK FOOTER //
// PrivacyPolicy.vue?b7c5cff6